import React, { useMemo } from 'react'
import { RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildOtherRecords } from './otherRecordsModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function OtherRecords({ person }) {
    const model = useMemo(() => buildOtherRecords(person), [person])
    if (!model.hasData) return <div className={styles.calmLine}>No other records found.</div>
    const groups = [
        [model.voters, plural(model.voters.length, 'voter registration')],
        [model.students, plural(model.students.length, 'possible student record')],
        [model.utilities, plural(model.utilities.length, 'utility connection')],
        [model.hunting, plural(model.hunting.length, 'hunting or fishing license', 'hunting or fishing licenses')],
    ].filter(([rows]) => rows.length)
    return (
        <div className={styles.uccList}>
            {groups.map(([rows, label]) => (
                <React.Fragment key={label}>
                    <div className={styles.uccGroupTitle}>{label}</div>
                    <RecordList items={rows} />
                </React.Fragment>
            ))}
        </div>
    )
}
